import {
    LOADING_TOGGLE_ACTION,
    LOGOUT_ACTION,
} from '../actions/AuthActions';

import {
    SIGNUP_CONFIRMED_ACTION,
    SIGNUP_FAILED_ACTION,
    LOGIN_CONFIRMED_ACTION,
    LOGIN_FAILED_ACTION,
    PASSWORD_RESET_STARTED_ACTION,
    PASSWORD_RESET_CONFIRMED_ACTION,
    RESET_MESSAGE_ACTION
} from '../../services/AuthService';

const initialState = {
    auth: {
        email: '',
        idToken: '',
        localId: '',
        expiresIn: '',
        refreshToken: '',
    },
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};

export function AuthReducer(state = initialState, action) {
    if (action.type === SIGNUP_CONFIRMED_ACTION) {
        return {
            ...state,
            auth: action.payload,
            errorMessage: '',
            successMessage: 'Please Confirm Your ' + action.payload.codeDeliveryDetails.AttributeName.charAt(0).toUpperCase() + action.payload.codeDeliveryDetails.AttributeName.slice(1),
            showLoading: false,
        };
    }
    if (action.type === LOGIN_CONFIRMED_ACTION) {
        return {
            ...state,
            auth: action.payload,
            errorMessage: '',
            successMessage: 'Login Successfully Completed',
            showLoading: false,
        };
    }

    if (action.type === LOGOUT_ACTION) {
        return {
            ...state,
            errorMessage: '',
            successMessage: '',
            auth: {
                email: '',
                idToken: '',
                localId: '',
                expiresIn: '',
                refreshToken: '',
            },
        };
    }

    if (
        action.type === SIGNUP_FAILED_ACTION ||
        action.type === LOGIN_FAILED_ACTION
    ) {
        return {
            ...state,
            errorMessage: action.payload,
            successMessage: '',
            showLoading: false,
        };
    }

    if ( action.type === PASSWORD_RESET_STARTED_ACTION ) {
        return{
            ...state,
            auth: action.payload,
            errorMessage: '',
            successMessage: 'If account exists and is verified, a 6 digit reset code has been sent to the email',
            showLoading: false,
        };
    }
    if ( action.type === PASSWORD_RESET_CONFIRMED_ACTION ) {
        return {
            ...state,
            auth: action.payload,
            errorMessage: '',
            successMessage: 'Password has been successful reset!',
            showLoading: false,
        };
    }

    if (action.type === LOADING_TOGGLE_ACTION) {
        return {
            ...state,
            showLoading: action.payload,
        };
    }

    if (action.type === RESET_MESSAGE_ACTION) {
        return {
            ...state,
            auth: action.payload,
            errorMessage: '',
            successMessage: '',
            showLoading: false,
        };
    }

    return state;
}

    
